/**
 * Created by WangPing on 2019/7/23.
 */
// import 'lib-flexible'
import './index.less'
import interactive from "../../assets/javascripts/interactive";
import {Render} from "../../assets/javascripts/common";
import '../../assets/javascripts/windvane.js'
import util from "../../assets/javascripts/util";

if (module.hot) {
    module.hot.accept()
}

let page = new interactive('BannerJSPlugin');
class Main extends Render{
    constructor(bridgeContext) {
        super(bridgeContext);
        this.campaignId = '';
        this.campaignIdList = [];
    }
    getCampaignIdList(){
        this.campaignIdList = this.bridgeContext.campaignList.map(function(item){
            return item.id
        })
        this.campaignId = this.campaignIdList[0];
    }
    // 初始化执行插入页面元素
    init() {
        this.initCampaignMap(); // 初始化campaignMap
        // this.insertPrivacy(); // 插入隐私政策弹窗
        this.getStar();//获取星星评级
        this.insertCta();// 插入cta文字
        if (this.campaignInfo.title) {
            this.insertTitle();// 插入title
        }
        if (this.campaignInfo.image_url) {
            this.insertImage();
        }
        if (this.campaignInfo.icon_url) {
            this.insertIcon();// 插入icon
        } else {
            let infoIcon = Array.from(document.getElementsByClassName("infoIcon"));
            for (let i of Array.from(infoIcon)) {
                i.classList.add('hide');    //  如果icon url不存在增加hide class隐藏
            }
        }
        if (this.campaignInfo.desc) {
            this.insertDes();// 插入描述
        }
        this.insertJumpUrl(()=>{
            page.click({
                bridgeContext:this.bridgeContext,
                campaignMap:this.campaignMap[this.campaignId],
                template:'banner'
            })
        })
    }
}
page.onJSBridgeConnected(function () {
    page.getBridgeContext({
        succ:function (res) {
            if(res.campaignList[0].image_url){
                let renderDom = new Main(res);
                renderDom.init();
                renderDom.getCampaignIdList();
                page.isReadyStatus(1,function () {
                    page.webviewshow(function () {
                        console.log("准备上报only_impression_url")
                        page.reportPv(res);// only_impression_url就发一次,上报banner pv
                        console.log("准备上报campaignid")
                        page.sendImpressions(res);   //上报campaignid
                        page.reportOfferImpression(res);
                        page.initBannerCloseBtn(res);  // 判断是否出关闭按钮
                    },res)
                })
            }else{
                page.isReadyStatus(2)
            }
        }
    })
})


